<template>
  <div>
    <div
      class="content_container_top"
      @mouseenter="ico =false"
      @mouseleave="ico = true"
      @click="scrollToTop"
      v-show="toTopShow"
      title="返回置顶"
    >
      <transition name="component-fade" mode="out-in">
        <i class="el-icon-arrow-up" style="line-height:50px" v-if="ico" key="ico"></i>
        <div v-else style="font-size:12px;" key="font">
          <p style="margin:10px 0 4px 0">返回</p>
          <p>置顶</p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      toTopShow: false,
      scrollTop: "",
      ico: true
    };
  },
  methods: {
    handleScroll() {
      // console.log(222)
      /* 获取回到顶部的位置元素 .content-container-top */
      // let dom =document.getElementsByClassName('content-container-top')[0];
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.scrollTop > 300) {
        this.toTopShow = true;
      } else {
        this.toTopShow = false;
      }
    },
    scrollToTop() {
      let timer = null;
      let _this = this;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (_this.scrollTop > 300) {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          _this.toTopShow = false;
        } else {
          cancelAnimationFrame(timer);
          _this.toTopShow = false;
        }
      });
    }
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener("scroll", this.handleScroll, true); // 取消事件冒泡，防止绑定失败
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll, true); // 取消事件冒泡
  }
};
</script>
<style >
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/scroll/index.vue